$(document).ready(function(){
  // disable Magnific Popup for product featured image
  $('.product-featured-image img').magnificPopup({
    disableOn: function() {
      return false;
    }
  });
  
  // configuration for thumbnail images in product page  
  lightbox.option({
    'alwaysShowNavOnTouchDevices': true,
    'fitImagesInViewport': true,
    'wrapAround': true
  });
  
  // product tumbnail slider  
  $('.custom-pro-thumbs').slick({
//     dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    //     autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 2000
  });

});